<div class="flex flex-col h-full max-h-[80vh]">
    <div class="flex justify-between p-6 border-b border-[#E7EAF0]">
        <div>
            <p class="text-[1.125rem] text-[#0A0A0A] font-bold">Gather your friends</p>
            <p class="text-[0.85rem] text-[#64748B]">Invite others to share in this community.</p>
        </div>

        <button type="button" (click)="onCancel()">
            <img class="h-5 w-5" src="/assets/images/auth/cross.svg" alt="Close" />
        </button>
    </div>
    <div class="py-3 px-6 border-b border-[#E7EAF0]">
        @if (data.newCreatedGroupDetail) {
            <div class="p-3 rounded-2xl border border-[#E7EAF0] mb-3">
                <div class="flex gap-3">
                    <img
                        class="w-auto max-h-16 h-auto rounded-lg"
                        alt="GroupIcon"
                        [src]="data.newCreatedGroupDetail.photo" />
                    <div class="space-y-1">
                        <div class="flex items-center gap-3">
                            <p class="text-[#0F172A] font-semibold text-sm">{{ data.newCreatedGroupDetail.name }}</p>
                            <div class="flex items-center gap-1">
                                <img
                                    alt="Privacy"
                                    class="h-3 w-3"
                                    [src]="
                                        data.newCreatedGroupDetail.privacy === PrivacyTypeEnum.Public
                                            ? '/assets/images/post/public-icon.svg'
                                            : data.newCreatedGroupDetail.privacy === PrivacyTypeEnum.Private
                                              ? '/assets/images/post/anonymous-icon.svg'
                                              : '/assets/images/post/friends-icon.svg'
                                    " />
                                <p class="text-[#475569] text-xs">
                                    {{ getPrivacyTypeLabel(data.newCreatedGroupDetail.privacy) }}
                                </p>
                            </div>
                        </div>

                        <p class="text-[#475569] text-xs">{{ data.newCreatedGroupDetail.description }}</p>
                        <div class="flex items-center gap-4">
                            @if (data.newCreatedGroupDetail.cats && data.newCreatedGroupDetail.cats.length !== 0) {
                                <div class="flex flex-wrap gap-2">
                                    @for (tag of data.newCreatedGroupDetail.cats; track tag.id) {
                                        <div
                                            class="px-3 py-1 rounded-full bg-white border border-[#e7eaf0] text-[#0a0a0a] text-[0.8rem] font-medium transition duration-150">
                                            {{ tag.name }}
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        }
        <p class="text-sm font-semibold text-[#0A0A0A]">Invite Member</p>
        <div class="relative mt-3">
            <img
                src="/assets/images/shared/search-icon.svg"
                alt="Toggle password visibility"
                class="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-auto" />
            <input
                id="searchInput"
                type="text"
                placeholder="Search for Users"
                class="w-full search-form-field-container rounded-2xl"
                (input)="onSearchInput($event.target.value)" />
        </div>
        <div class="flex flex-col mt-3 pr-3 max-h-[25vh] overflow-y-auto popup-scrollable-main">
            @if (isInitialLoading()) {
                @for (i of [1, 2, 3]; track i) {
                    <div class="flex items-center p-3">
                        <ngx-skeleton-loader appearance="circle" [theme]="{ width: '48px', height: '48px' }">
                        </ngx-skeleton-loader>

                        <ngx-skeleton-loader class="w-40 h-4 rounded-md ml-4"></ngx-skeleton-loader>
                    </div>
                }
            } @else if (usersData().length !== 0) {
                <div
                    class="flex flex-col p-3 gap-3"
                    infiniteScroll
                    [infiniteScrollContainer]="'.popup-scrollable-main'"
                    [fromRoot]="true"
                    [infiniteScrollDistance]="1"
                    (scrolled)="onScroll()">
                    @for (item of usersData(); track item.id) {
                        <div class="flex justify-between items-center">
                            <div class="flex items-center">
                                @if (item?.photo !== ' ' && item?.photo) {
                                    <img
                                        class="h-12 w-12 rounded-full object-cover border border-[#e7eaf0]"
                                        alt="Profile"
                                        [src]="item?.photo" />
                                } @else {
                                    <div
                                        class="h-12 w-12 rounded-full border border-[#e7eaf0] bg-[#4F66FF] text-white flex items-center justify-center font-bold text-[1.2rem]">
                                        {{ item?.name?.charAt(0) | uppercase }}
                                    </div>
                                }
                                <p class="text-[#0A0A0A] font-medium ml-4">{{ item.name }}</p>
                            </div>
                            <input
                                type="checkbox"
                                class="checkbox-button"
                                [checked]="selectedUsers().includes(item.id)"
                                (change)="toggleUser(item.id, $event.target.checked)" />
                        </div>
                    }
                </div>
            } @else {
                <div class="text-center text-[#717182] py-10">No users found</div>
            }
        </div>
    </div>
</div>
<mat-dialog-actions class="gap-5">
    @if (data.newCreatedGroupDetail) {
        <p class="text-[#475569] font-bold cursor-pointer" (click)="onCancel()">Skip for now</p>
    }
    <button
        type="button"
        class="border-button sm:py-3 px-6 p-2 rounded-full bg-[#0047ff] min-w-28"
        [disabled]="selectedUsers().length === 0"
        (click)="inviteSelectedUsers()">
        Invite
    </button>
</mat-dialog-actions>
